import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LoadingPanelComponent } from '../../modules/loading/components/loading-panel.component';

@Injectable({
    providedIn: 'root'  // <--provides this service in the root ModuleInjector
})
export class DialogService {
    //public spinner: boolean = false;
    public loadingPanelComponent: LoadingPanelComponent;
    constructor() {
    }
    showSpinner() {
        //this.spinner = true;
        if (this.loadingPanelComponent)
            this.loadingPanelComponent.loadPanelVisible = true;
    }
    hideSpinner() {
        //this.spinner = true;
        if (this.loadingPanelComponent)
            this.loadingPanelComponent.loadPanelVisible = false;
    }
    confirm(message?: string): Observable<boolean> {
        const confirmation = window.confirm(message || 'Is it OK?');

        return of(confirmation);
    };
}
